import { useState, useEffect } from 'react';
import { ScanSearch } from 'lucide-react';
import { Button } from './ui/button';
import { api } from './invoice/api';

export function PendingScansBanner({ mois, onOpen, onCount, hidden }) {
    const [n, setN] = useState(null);
    useEffect(() => {
        const get = () => api.list({ statut: 'en_attente', limit: 1, ...(mois ? { mois_facture: mois } : {}) }).then(r => { setN(r.total); onCount?.(r.total); }).catch(() => setN(null));
        get();
        const t = setInterval(get, 60000);
        return () => clearInterval(t);
    }, [mois]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!n || hidden) return null;
    return (
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3" data-testid="pending-scans-banner">
            <p className="flex-1 text-[13px] text-amber-900">
                <b data-testid="pending-scans-count">{n}</b> facture(s) scannée(s){mois ? ' de ce mois' : ''} attendent votre contrôle. Elles ne sont comptées en dépense qu'après validation.
            </p>
            <Button size="sm" onClick={() => onOpen(mois)} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="pending-scans-open"><ScanSearch className="w-4 h-4 mr-1" />Contrôler les factures</Button>
        </div>
    );
}
